import React from 'react'

const GarethPayne = () =>
  <div className="page bio">
    Gareth Payne
  </div>

export default GarethPayne
